import { error, json } from "@sveltejs/kit";
import { p as prisma } from "../../../../../../chunks/prisma.js";
import auth from "../../../../../../chunks/auth.js";
import { randomUUID, createHash } from "crypto";
import { existsSync, mkdirSync, createWriteStream, unlinkSync } from "fs";
import path from "path";
const MAX_BYTES = 25 * 1024 * 1024;
const GET = async ({ params, locals }) => {
  const productId = Number(params.id);
  if (Number.isNaN(productId)) throw error(400, "Invalid product id");
  const product = await prisma.product.findUnique({
    where: { id: productId, isPublished: true }
  });
  if (!product) throw error(404, "Product not found");
  const docs = await prisma.productDocument.findMany({
    where: { productId, isPublished: true },
    select: { id: true, originalName: true, sizeBytes: true },
    orderBy: { sortOrder: "asc" }
  });
  if (!locals.isSubscribed) {
    return json({ count: docs.length });
  }
  return json({ documents: docs });
};
const POST = async ({ params, request, locals }) => {
  const user = locals.user;
  if (!await auth.isAdmin(user)) throw error(401, "Unauthorized");
  const productId = Number(params.id);
  if (Number.isNaN(productId)) throw error(400, "Invalid product id");
  const product = await prisma.product.findUnique({ where: { id: productId } });
  if (!product) throw error(404, "Product not found");
  const form = await request.formData();
  const file = form.get("file");
  if (!file) throw error(400, "Missing file");
  if (file.type !== "application/pdf") throw error(400, "Only PDF allowed");
  if (file.size > MAX_BYTES) throw error(413, "File too large");
  const dir = path.join("uploads", "product-documents", String(productId));
  if (!existsSync(dir)) mkdirSync(dir, { recursive: true });
  const storedName = `${randomUUID()}.pdf`;
  const fullPath = path.join(dir, storedName);
  const arrayBuffer = await file.arrayBuffer();
  const buffer = Buffer.from(arrayBuffer);
  const hash = createHash("sha256").update(buffer).digest("hex");
  const existing = await prisma.productDocument.findFirst({
    where: { productId, originalName: file.name }
  });
  await new Promise((resolve, reject) => {
    const ws = createWriteStream(fullPath);
    ws.on("finish", () => resolve());
    ws.on("error", (e) => reject(e));
    ws.end(buffer);
  });
  let doc;
  if (existing) {
    try {
      if (existing.storedName && existing.storedName !== storedName) {
        const oldPath = path.join(dir, existing.storedName);
        if (existsSync(oldPath)) unlinkSync(oldPath);
      }
    } catch (e) {
      console.warn("Warn: failed deleting old product document file", e);
    }
    doc = await prisma.productDocument.update({
      where: { id: existing.id },
      data: {
        originalName: file.name,
        storedName,
        sizeBytes: file.size,
        mimeType: file.type,
        checksumSha256: hash
      }
    });
  } else {
    doc = await prisma.productDocument.create({
      data: {
        productId,
        originalName: file.name,
        storedName,
        sizeBytes: file.size,
        mimeType: file.type,
        checksumSha256: hash
      }
    });
  }
  return json({ success: true, document: { id: doc.id, originalName: doc.originalName } });
};
export {
  GET,
  POST
};
